const MenuIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 42.872 31.813"
      className="stroke-current"
    >
      <g id="BURGER_MENU" data-name="BURGER MENU" transform="translate(0 1.5)">
        <g
          id="Group_9434"
          data-name="Group 9434"
          transform="translate(-50.008 -43.5)"
        >
          <line
            id="Line_177"
            data-name="Line 177"
            x2="42.872"
            transform="translate(50.008 43.5)"
            fill="none"
            strokeWidth={3}
          />
          <line
            id="Line_178"
            data-name="Line 178"
            x2="42.872"
            transform="translate(50.008 57.906)"
            fill="none"
            strokeWidth={3}
          />
          <line
            id="Line_179"
            data-name="Line 179"
            x2="42.872"
            transform="translate(50.008 72.313)"
            fill="none"
            strokeWidth={3}
          />
        </g>
      </g>
    </svg>
  )
}

export default MenuIcon
